/**
 * The one place that says what leaves the browser when a session ends.
 *
 * Every path that ends a session calls this, and so does every path that starts
 * one: a session ended by some route not enumerated here must not hand its state
 * to the next user on a shared browser.
 *
 * Not React-aware — it clears storage only, so callers keep their own query-cache
 * clear, observability identity and state resets.
 */

// From the hook module, not the `components/v4/records/filter` barrel:
// apiTransport imports this module, so anything the barrel re-exports that
// reaches back to utils/api would close a cycle — and a cycle stays invisible
// until a binding is read during module evaluation.
import { clearFilterStorage } from '../components/v4/records/filter/hooks/useFilterState';
import { clearActingOrgStorage } from './actingOrg';

/** Remove every trace of the current session from browser storage. */
export function endSession(): void {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('isAuthenticated');
  clearActingOrgStorage();
  clearFilterStorage();
}
